"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressChangeBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var commonFunctions_1 = require("../../commonFunctions");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var AddressChangeBanner = /** @class */ (function (_super) {
    __extends(AddressChangeBanner, _super);
    function AddressChangeBanner(props) {
        return _super.call(this, props) || this;
    }
    AddressChangeBanner.prototype.render = function () {
        var interaction = this.props.interaction;
        var wording = "Changes in your address might affect your cover price.";
        if (interaction.factors && interaction.factors.debtAmount) {
            wording = wording + " Your change address quote will include your missed payment of " +
                (0, commonFunctions_1.getAmountWithDecimalDigits)(interaction.factors.debtAmount) + " to bring your account up to date.";
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "banner info-banner", children: [(0, jsx_runtime_1.jsx)("div", { className: "banner-icon" }), (0, jsx_runtime_1.jsx)("div", { className: "banner-text font-weight-bold", children: wording })] }));
    };
    return AddressChangeBanner;
}(plugin_journey_1.WidgetBase));
exports.AddressChangeBanner = AddressChangeBanner;
//# sourceMappingURL=AddressChangeBanner.js.map